import * as React from "react";
import { useField } from 'informed';
import { Required } from "../validation/Required";
import { inputClasses } from "../validation/ValidationClasses";
import { replaceDotsWithHyphens } from "../../misc/Helpers/StringHelper";

interface TimePickerProps {
    id: string;
    field: string;
    label: string;
    dateFormat: string;
    placeholderText?: string;
    className?: string;
    disabled?: boolean;
    required?: boolean;
    suffix?: React.ReactNode | string;
    defaultValue?: string;
    step?: number;
}

export const TimePicker = ({ id, field, label, placeholderText, disabled, required, suffix, defaultValue, step }: TimePickerProps) => {
    const { fieldState, fieldApi } = useField<string>({ field: field, validate: required ? Required : undefined, value: defaultValue ? defaultValue : undefined });
    const { value } = fieldState;
    const { setValue } = fieldApi;

    return (
        <>
            <label htmlFor={id}>{label}</label>
            <div className={suffix ? "input-group" : ""}>
                <input
                    id={id}
                    data-automationid={replaceDotsWithHyphens(field)}
                    type="time"
                    className={inputClasses(fieldApi.getError())}
                    value={value}
                    onChange={(e) => setValue(e.target.value)}
                    placeholder={placeholderText}
                    required={required}
                    disabled={disabled}
                    step={step}
                />
                {suffix ? <span className="input-group-addon">{suffix}</span> : null}
            </div>
            {fieldApi.getError() ? <span className="field-validation-error">{fieldApi.getError()}</span> : null}
        </>
    );
}
